let $popup = $('.video-popup')
let $body = $('body')
let $html = $('html')

function closePopup()
{
  $popup.removeClass('popup-visible')
  $html.removeClass('popup-open')
  $popup.find('.js-video-content').html('')
}

function openPopup(popupContentID)
{
  let content = $('[data-video-popup-content="'+popupContentID+'"]')

  if(content.length) {

    $popup.find('.js-video-content').html(content.html())

    let iframe = $popup.find('iframe')
    iframe.attr('src', iframe.data('src'))

    $popup.addClass('popup-visible')
    $html.addClass('popup-open')
  }

}

$body.on('click', '[data-video-popup-content-link]', function (e){
  e.preventDefault()
  let popupContentID = $(this).data('video-popup-content-link')
  openPopup(popupContentID)
})

$body.on('click', '.js-close-video-popup, .js-background-popup', function (e){
  e.preventDefault()
  closePopup()
})

$(document).keyup(function(e) {
  if (e.key === "Escape" && $popup.is(':visible')) { // escape key maps to keycode `27`
    closePopup()
  }
});
